import React from 'react';

import PageWrapper from '../PageWrapper';
import Page from '../Page';
import { RouteComponentProps } from 'react-router';
import { BrandLogo } from '@go-client/components/UIkit/Brand/BrandLogo/BrandLogo';

import { PropertyBanner } from '@go-client/components/UIkit/Property/PropertyBanner';
import { MenuBar } from '@go-client/components';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';
import { BubbleAccordion, BubbleAlert } from '@go-client/components/BubbleUI';
import ReserveNavigation from '@go-client/components/Navigations/ReserveNavigation';

interface ReserveAnalyzeParams {
  property: string;
}

type ReserveAnalyzeProps = RouteComponentProps<ReserveAnalyzeParams>;

export default function ReserveAnalyze(props: ReserveAnalyzeProps) {
  const { activeProperty } = useActiveProperty();

  return (
    <PageWrapper {...props}>
      <Page className="Reservables absolute flex items-stretch">
        <MenuBar {...props} property={activeProperty} />
        <div className="SideMenu bg-turquoise-darkest flex flex-col">
          <div className="bg-white flex flex-col items-center">
            <BrandLogo logo={activeProperty.brand.logo} />
            <PropertyBanner {...props} property={activeProperty} swappable />
          </div>
          <div className={`flex flex-col relative items-stretch p-4 bg-turquoise-darker`}>
            <div className="grid gap-2"></div>
          </div>
          <BubbleAccordion
            variant="turquoise"
            className="flex-grow flex flex-col border-t border-turquoise-darkest"
            labels={['Filters']}
            open={[0]}
            locked={[0]}
          >
            <div className="grid gap-4"></div>
          </BubbleAccordion>
        </div>
        <div className="ReservablesContent bg-blue-lightest overflow-y-auto flex-grow">
          <div
            className="ReservablesHeader align-with-logo flex items-end px-5 sticky top-0
              left-0 z-10 bg-blue-lightest"
          >
            <div className="mb-3 pl-3 flex-grow flex items-end">
              <ReserveNavigation active="analyze" />
            </div>
          </div>
          <div className="ReservablesBody mx-5 content-minus-logo min-w-900">
            <BubbleAlert variant="banana">Under construction</BubbleAlert>
            <div className="mt-3">&nbsp;</div>
          </div>
        </div>
      </Page>
    </PageWrapper>
  );
}
